import { Preferences } from '@capacitor/preferences'
import { updateRequestStatus } from '@ngneat/elf-requests'

import {
  AuthenticationResponse,
  LoginInterface,
  SignupInterface,
  SignupInterfaceApi,
  CountryParams,
  ContactUsData,
} from '../../models/sessions.models'
import { User, ApiUser, UserType, UserStats } from '../../models/users.models'
import { Mode, Currency, FilterableRoute, Accessibility } from '../../models/commons.models'
import { PlatformReference, getPlatform } from '../../models/platforms.models'
import { CatalogType, isNeeds, isResources, CatalogIcon } from '../../models/catalogs.models'
import {
  MaterialType,
  MaterialState,
  Unit,
  MaterialQuantity,
  DimensionUnit,
  CerfaWaste,
  Material,
} from '../../models/materials.models'
import Cookies from 'js-cookie'

import { sessionStore } from './session.store'
import { sessionQuery } from './session.query'
import { catalogsService } from '../catalogs/catalogs.service'

import { NetworkUtils } from '../../utils/networks.utils'
import { logIfDev } from '../../utils/commons.utils'
import i18n from '../../utils/i18n.utils'
import { FileUtils } from '../../utils/files.utils'

import { setAuthorization, setLang } from '../../api/base.api'
import { FilesApi } from '../../api/files.api'
import { SessionsApi } from '../../api/sessions.api'

import Constants from '../../constants'

import { LangEnum } from '../../constants/langs'
import { changeLanguage } from '../../utils/i18n.utils'
import { Organization } from '../../models/organizations.models'
import { usersService } from '../users'

type ShowStatus = { type: CatalogType; isPublic: boolean } | { type: 'user' }

const Correspondences = [
  {
    oldCat: {
      tertiaryCategory: 'Cloisons modulaires',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 117,
      tertiaryCategory: 119,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Plaques plâtre',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 117,
      tertiaryCategory: 118,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Rideaux',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 96,
      tertiaryCategory: 102,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Escalier bois',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 124,
      tertiaryCategory: 132,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Fibre',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 121,
      tertiaryCategory: 122,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Métal P',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 121,
      tertiaryCategory: 122,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Plâtre P',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 121,
      tertiaryCategory: 122,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Chassis vitrés',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 124,
      tertiaryCategory: 131,
    },
  },
  {
    oldCat: {
      tertiaryCategory: "Panneaux d'habillage",
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 150,
      secondaryCategory: 158,
      tertiaryCategory: 162,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Plinthes',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 150,
      secondaryCategory: 151,
      tertiaryCategory: 155,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Portes intérieures',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 124,
      tertiaryCategory: 125,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Poignée',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 134,
      tertiaryCategory: 135,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Serrure',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 134,
      tertiaryCategory: 137,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Déblais divers',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 19,
      tertiaryCategory: 20,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Enrobés',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 8,
      tertiaryCategory: 9,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Abri extérieur',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 35,
      tertiaryCategory: 39,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Cailloux',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 2,
      tertiaryCategory: 3,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Clôture',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 19,
      tertiaryCategory: 23,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Mobilier extérieur',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 35,
      tertiaryCategory: 41,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Végétaux',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 19,
      tertiaryCategory: 21,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Canalisations',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 13,
      tertiaryCategory: 14,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Ouvrage enterré',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 13,
      tertiaryCategory: 16,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Regards',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 13,
      tertiaryCategory: 16,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Bordures',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 2,
      tertiaryCategory: 4,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Équipement de parking',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 2,
      tertiaryCategory: 7,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Pavés',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 8,
      tertiaryCategory: 12,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Signalisation',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 2,
      tertiaryCategory: 5,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Chevrons',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 58,
      tertiaryCategory: 60,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Fermes',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 58,
      tertiaryCategory: 60,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Liteaux',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 58,
      tertiaryCategory: 60,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Pannes',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 58,
      tertiaryCategory: 60,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Poutres',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 58,
      tertiaryCategory: 59,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Voliges',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 58,
      tertiaryCategory: 64,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Charpente',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 66,
      tertiaryCategory: 69,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Fermes M',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 66,
      tertiaryCategory: 69,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Pannes M',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 66,
      tertiaryCategory: 68,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Poutres M',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 66,
      tertiaryCategory: 68,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Acier',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 76,
      tertiaryCategory: 77,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Aluminium',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 76,
      tertiaryCategory: 77,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Tuiles',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 76,
      tertiaryCategory: 79,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Zinc',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 76,
      tertiaryCategory: 77,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Protection lourde',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 72,
      tertiaryCategory: 74,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Solins',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 72,
      tertiaryCategory: 75,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Chéneaux',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 72,
      tertiaryCategory: 75,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Professionnel',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 84,
      tertiaryCategory: 86,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Assise',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 205,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Autres',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 208,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Bureau',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 205,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Placards',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 206,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Restauration',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 205,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Particulier M',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 208,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Professionnel M',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 192,
      tertiaryCategory: 193,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Bois B',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 89,
      tertiaryCategory: 90,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Métal B',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 89,
      tertiaryCategory: 90,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Panneaux Composites',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 89,
      tertiaryCategory: 90,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Portes',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 96,
      tertiaryCategory: 99,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Stores',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 96,
      tertiaryCategory: 102,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Volets roulants',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 96,
      tertiaryCategory: 102,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Laine de bois',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 105,
      secondaryCategory: 106,
      tertiaryCategory: 108,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Laine de roche',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 105,
      secondaryCategory: 106,
      tertiaryCategory: 108,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Laine Minérale',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 105,
      secondaryCategory: 106,
      tertiaryCategory: 108,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Ouate de Cellulose',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 105,
      secondaryCategory: 112,
      tertiaryCategory: 113,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Polystyrène',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 105,
      secondaryCategory: 106,
      tertiaryCategory: 108,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Bois E',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 96,
      tertiaryCategory: 104,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Métal E',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 96,
      tertiaryCategory: 104,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'PVC',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 96,
      tertiaryCategory: 104,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Briques',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 32,
      tertiaryCategory: 34,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Éléments préfabriqués',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 49,
      tertiaryCategory: 54,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Parpaings',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 49,
      tertiaryCategory: 54,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Bâtie',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 49,
      tertiaryCategory: 55,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Moellon',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 49,
      tertiaryCategory: 56,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Parement',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 89,
      tertiaryCategory: 91,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Pierre de taille',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 49,
      tertiaryCategory: 55,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Sol',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 150,
      secondaryCategory: 151,
      tertiaryCategory: 152,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Poteaux',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 66,
      tertiaryCategory: 68,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Éléments Cabine',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 196,
      tertiaryCategory: 201,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Moteur',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 196,
      tertiaryCategory: 201,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Groupe de condensation',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 192,
      tertiaryCategory: 194,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Cheminées',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 84,
      tertiaryCategory: 85,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'PAC',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 172,
      tertiaryCategory: 175,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Radiateurs',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 172,
      tertiaryCategory: 176,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Cassette',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 172,
      tertiaryCategory: 176,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Split',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 172,
      tertiaryCategory: 176,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Chemin de câbles',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 179,
      tertiaryCategory: 181,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Éclairage',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 179,
      tertiaryCategory: 183,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Incendie',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 190,
      tertiaryCategory: 191,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Petit Appareillage',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 179,
      tertiaryCategory: 185,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Réseau VDI',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 186,
      tertiaryCategory: 187,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Tableaux',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 179,
      tertiaryCategory: 180,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Accessoires',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 164,
      tertiaryCategory: 171,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Appareils sanitaires',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 164,
      tertiaryCategory: 171,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'CTA',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 172,
      tertiaryCategory: 177,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Gaines',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 172,
      tertiaryCategory: 177,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Grille',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 172,
      tertiaryCategory: 177,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Durs R',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 150,
      secondaryCategory: 158,
      tertiaryCategory: 159,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Souples R',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 150,
      secondaryCategory: 158,
      tertiaryCategory: 162,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Textile',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 121,
      tertiaryCategory: 122,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Durs',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 150,
      secondaryCategory: 151,
      tertiaryCategory: 152,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Parquet',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 150,
      secondaryCategory: 151,
      tertiaryCategory: 154,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Souples',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 150,
      secondaryCategory: 151,
      tertiaryCategory: 153,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Éléments',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 146,
      tertiaryCategory: 149,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Main courante',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 141,
      tertiaryCategory: 142,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Ouvrage technique',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 141,
      tertiaryCategory: 145,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Architectural E',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 141,
      tertiaryCategory: 143,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Architectural',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 141,
      tertiaryCategory: 142,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Technique',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 84,
      tertiaryCategory: 87,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Porte coulissante',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 146,
      tertiaryCategory: 148,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Porte métallique',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 146,
      tertiaryCategory: 147,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Arrosage',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 13,
      tertiaryCategory: 18,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Terre Végétale',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 19,
      tertiaryCategory: 20,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Briquettes',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 49,
      tertiaryCategory: 54,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Monomur',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 49,
      tertiaryCategory: 54,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Carrobric',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 49,
      tertiaryCategory: 54,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Escalier intérieur',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 49,
      tertiaryCategory: 51,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Escalier extérieur',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 49,
      tertiaryCategory: 51,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Fermettes',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 58,
      tertiaryCategory: 60,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Liteaux M',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 42,
      secondaryCategory: 58,
      tertiaryCategory: 60,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Solins Z',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 71,
      secondaryCategory: 72,
      tertiaryCategory: 75,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Skydôme',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 96,
      tertiaryCategory: 101,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Velux',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 96,
      tertiaryCategory: 101,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Lanterneau',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 190,
      tertiaryCategory: 191,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Ossature',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 89,
      tertiaryCategory: 95,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Doublage composite',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 105,
      secondaryCategory: 106,
      tertiaryCategory: 108,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Mixtes Bois/Alu',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 88,
      secondaryCategory: 96,
      tertiaryCategory: 100,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Rideau métallique',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 146,
      tertiaryCategory: 147,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Extérieure Q',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 116,
      secondaryCategory: 134,
      tertiaryCategory: 139,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Intérieur',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 141,
      tertiaryCategory: 142,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Intérieur E',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 141,
      tertiaryCategory: 143,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Portails',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 19,
      tertiaryCategory: 24,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Ensemble',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 19,
      tertiaryCategory: 23,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Canalisations C',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 172,
      tertiaryCategory: 174,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Chauffe eau',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 164,
      tertiaryCategory: 165,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Téléphonie',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 186,
      tertiaryCategory: 187,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Évaporateur',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 192,
      tertiaryCategory: 194,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Scolaire',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 35,
      tertiaryCategory: 40,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Extérieur',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 35,
      tertiaryCategory: 40,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Armoires',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 206,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Étagères',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 206,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Miroir',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 207,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Autre',
      secondaryCategory: 'Décoration',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 207,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Levage',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 196,
      tertiaryCategory: 201,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Autre',
      secondaryCategory: 'Outillage',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 196,
      tertiaryCategory: 201,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Scénographie',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 212,
      tertiaryCategory: 213,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'AccessoireA',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 212,
      tertiaryCategory: 213,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Finition sol',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 150,
      secondaryCategory: 151,
      tertiaryCategory: 157,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Technique E',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 140,
      secondaryCategory: 141,
      tertiaryCategory: 143,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Détection',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 163,
      secondaryCategory: 186,
      tertiaryCategory: 189,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Établi',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 205,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Devanture',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 207,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Accessoire',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 208,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Equipement de parking',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 1,
      secondaryCategory: 35,
      tertiaryCategory: 41,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Etabli',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 208,
    },
  },
  {
    oldCat: {
      tertiaryCategory: 'Etagères',
      secondaryCategory: '',
    },
    newCat: {
      primaryCategory: 203,
      secondaryCategory: 204,
      tertiaryCategory: 206,
    },
  },
]
export class SessionService {
  store = sessionStore

  get storageAdminPlatformKey() {
    return `ADMIN_PLATFORM_${Constants.platform}`
  }

  async setUseImperials(useImperials: boolean) {
    this.store.update((state) => ({
      ...state,
      useImperials,
      user: state.user
        ? {
            ...state.user,
            useImperials,
          }
        : undefined,
    }))

    try {
      await Preferences.set({
        key: this.storageUseImperialKey,
        value: useImperials + '',
      })
    } catch (err: any) {
      logIfDev(err)
    }

    if (this.store.getValue().user?._id) {
      try {
        await usersService.updateUser(this.store.getValue().user!._id, { useImperials })
      } catch (err) {
        logIfDev(err)
      }
    }
  }

  enableCerfa(): boolean {
    return Constants.mode === Mode.admin || sessionQuery.getEnabelCerfa()
  }

  catalogIcon(): CatalogIcon | undefined {
    let platformRef = Constants.mode === Mode.admin ? this.getAdminPlatform() : Constants.platform
    const platform = getPlatform(platformRef)
    return platform?.catalogIcon
  }

  showStatus(params: ShowStatus): boolean {
    let platformRef = Constants.mode === Mode.admin ? this.getAdminPlatform() : Constants.platform
    const platform = getPlatform(platformRef)
    if (params.type === 'user') {
      return !platform.autoValidations[params.type]
    }
    const type = isNeeds(params.type) ? 'needs' : 'resources'
    return !params.isPublic && !platform.autoValidations[type]
  }

  showPublicNeeds() {
    return this.showPublic(CatalogType.construction)
  }
  showPublic(type: MaterialType | CatalogType) {
    let platformRef = Constants.mode === Mode.admin ? this.getAdminPlatform() : Constants.platform
    const platform = getPlatform(platformRef)
    return (
      isResources(type as CatalogType) || type === MaterialType.resource || platform.publicNeeds
    )
  }

  get storageAuthKey() {
    return `AUTH_${Constants.platform}`
  }
  get storageCountryKey() {
    return `COUNTRY_${Constants.platform}`
  }
  get storageUseImperialKey() {
    return `USEIMPERIAL_${Constants.platform}`
  }

  async getCountry(countryCode: string) {
    return await SessionsApi.getCountry(countryCode)
  }

  getCountryParam(key: keyof CountryParams) {
    return this.store.getValue().countryParams[key]
  }

  async checkAppVersion() {
    if (Constants.mode === Mode.app) {
      let logout = false
      let savedVersion
      try {
        ;({ savedVersion } = await FileUtils.readJSON('config'))
      } catch (err) {}

      try {
        // TRY MIGRATION OF LOCAL DATA
        if (!savedVersion) {
          // update when before adding version handle : 23-10-27
          logIfDev('update to 1')
          savedVersion = 1
        }
        if (savedVersion <= 1.01) {
          // update when TM went to SAAS : ~ 23-12-01
          logIfDev('update to 1.02')
          await catalogsService.migrateLocals(async ({ catalog, materials }: any) => {
            if (
              catalog?.interventionTypes?.find(
                (interventionType: string) =>
                  interventionType === 'resourceCenter' || interventionType === 'storaryArea',
              )
            ) {
              delete catalog?.interventionTypes
              catalog.type = 'storage'
            } else {
              catalog.interventionTypes = catalog?.interventionTypes?.map(
                (interventionType: string) =>
                  interventionType === 'layout' ? 'layoutVRD' : interventionType,
              )
            }

            materials = materials?.map((material: any) => ({
              ...material,
              state:
                material.state === MaterialState.awaitingDeposit ||
                material.state === MaterialState.deposited
                  ? material.state
                  : undefined,
              quantities: material.quantities.map((quantity: any) => ({
                ...quantity,
                type: quantity.order ? 'order' : quantity.position ? 'inventory' : 'others',
              })),
            }))

            return { catalog, materials }
          })
          savedVersion = 1.02
        }

        if (savedVersion <= 1.02) {
          // update when internationalization : ~ 23-12-01
          logIfDev('update to 1.03')
          await catalogsService.migrateLocals(async ({ catalog, materials }: any) => {
            catalog.currency = Currency.EUR
            if (catalog.location) {
              catalog.location.countryCode = 'FR'
            }
            if (catalog.retrieval?.location) {
              catalog.retrieval.location.countryCode = 'FR'
            }

            materials = materials?.map((material: any) => ({
              ...material,
              currency: Currency.EUR,
            }))

            return { catalog, materials }
          })
          savedVersion = 1.03

          // logout to make sure we get lang/currency/countryCode of the user (or user organization)
          logout = true
        }

        if (savedVersion <= 1.03) {
          // update when update imperials unit : ~ 24-06-20
          logIfDev('update to 1.04')
          await catalogsService.migrateLocals(async ({ catalog, materials }: any) => {
            materials = materials?.map((material: any) => {
              if (material.unit === 'lft' || material.unit === 'lft' || material.unit === 'lft') {
                const factor =
                  material.unit === 'lft'
                    ? 3.28084
                    : material.unit === 'ft2'
                    ? 3.28084 * 3.28084
                    : material.unit === 'ft3'
                    ? 3.28084 * 3.28084 * 3.28084
                    : 1
                material = {
                  ...material,
                  unit:
                    material.unit === 'lft'
                      ? Unit.linearMeters
                      : material.unit === 'ft2'
                      ? Unit.squareMeters
                      : material.unit === 'ft3'
                      ? Unit.cubicMeters
                      : material.unit,
                  quantities: material.quantities.map((q: MaterialQuantity) => ({
                    ...q,
                    quantity: q.quantity / factor,
                  })),
                  initialQty: material.initialQty
                    ? material.initialQty / factor
                    : material.initialQty,
                  currentQty: material.currentQty
                    ? material.currentQty / factor
                    : material.currentQty,
                  reservedQty: material.reservedQty
                    ? material.reservedQty / factor
                    : material.reservedQty,
                  sellByQuantityOf: material.sellByQuantityOf
                    ? material.sellByQuantityOf / factor
                    : material.sellByQuantityOf,
                  minQuantity: material.minQuantity
                    ? material.minQuantity / factor
                    : material.minQuantity,
                  unitWeight: material.unitWeight
                    ? material.unitWeight * factor
                    : material.unitWeight,
                  price: material.price ? material.price * factor : material.price,
                }
              }
              if (
                material.dimensions.unit === 'in' ||
                material.dimensions.unit === 'ft' ||
                material.dimensions.unit === 'yd'
              ) {
                const factor =
                  material.dimensions.unit === 'in'
                    ? 25.4
                    : material.dimensions.unit === 'ft'
                    ? 30.48
                    : material.dimensions.unit === 'yd'
                    ? 0.9144
                    : 1

                material.dimensions = {
                  unit:
                    material.dimensions.unit === 'in'
                      ? DimensionUnit.millimeters
                      : material.dimensions.unit === 'ft'
                      ? DimensionUnit.centimeters
                      : material.dimensions.unit === 'yd'
                      ? DimensionUnit.meters
                      : material.dimensions.unit,
                  length: material.dimensions.length
                    ? material.dimensions.length * factor
                    : material.dimensions.length,
                  width: material.dimensions.width
                    ? material.dimensions.width * factor
                    : material.dimensions.width,
                  height: material.dimensions.height
                    ? material.dimensions.height * factor
                    : material.dimensions.height,
                  diameter: material.dimensions.diameter
                    ? material.dimensions.diameter * factor
                    : material.dimensions.diameter,
                }
              }

              return material
            })

            return { catalog, materials }
          })
          savedVersion = 1.04
        }

        if (savedVersion <= 1.04) {
          // update when update newCategory&PEMD : ~ 24-12-20
          logIfDev('update to 1.05')
          await catalogsService.migrateLocals(async ({ catalog, materials }: any) => {
            materials = materials?.map((material: any) => {
              const corr =
                Correspondences.find(
                  (corr) =>
                    corr.oldCat.tertiaryCategory === material.tertiaryCategory.name &&
                    (!corr.oldCat.secondaryCategory ||
                      corr.oldCat.secondaryCategory === material.secondaryCategory.name),
                ) ?? Correspondences[0]

              return { ...material, ...corr.newCat }
            })

            return { catalog, materials }
          })
          savedVersion = 1.05
        }

        if (savedVersion <= 1.05) {
          // update when update Accessibility : ~ 25-04-24
          logIfDev('update to 1.06')
          await catalogsService.migrateLocals(async ({ catalog, materials }: any) => ({
            catalog: {
              ...catalog,
              accessibility: catalog.visible ? Accessibility.public : Accessibility.private,
            },
            materials: materials?.map((material: any) => {
              return {
                ...material,
                accessibility:
                  material.visible === false ? Accessibility.private : Accessibility.public,
              }
            }),
          }))
          savedVersion = 1.06
        }

        if (savedVersion <= 1.06) {
          // update when updating cstb waste category : ~ 25-07-21
          logIfDev('update to 1.06')
          await catalogsService.migrateLocals(async ({ catalog, materials }: any) => ({
            catalog,
            materials: materials?.map((material: Material) => {
              return {
                ...material,
                cerfaWaste: material.cerfaWaste
                  ? material.cerfaWaste.map((cerfaWaste: CerfaWaste) => ({
                      ...cerfaWaste,
                      ...(cerfaWaste.primaryCategory === 65 && {
                        primaryCategory: 61,
                        secondaryCategory: 550,
                      }),
                      ...(cerfaWaste.tertiaryCategory === 123 && {
                        primaryCategory: 62,
                        secondaryCategory: 123,
                      }),
                    }))
                  : undefined,
              }
            }),
          }))
          savedVersion = 1.07
        }

        // current version 1.07
        // if (savedVersion <= 1.07) {
        // }
      } catch (err) {
        logIfDev(err)
      }
      try {
        await FileUtils.writeJSON('config', { savedVersion: Constants.appVersion })
      } catch (err) {}

      if (logout) {
        this.logout()
      }
    }
  }

  getAdminPlatform(): PlatformReference {
    return this.store.getValue().adminPlatform
  }
  getAdminPlatformType(): Mode {
    const platform = getPlatform(this.getAdminPlatform())
    return platform?.mode
  }
  async setAdminPlatform(platform: PlatformReference) {
    if (platform !== this.getAdminPlatform()) {
      await this.storePlatform(platform)
      window.location.reload()
    }
  }
  storePlatform = async (platform: PlatformReference) => {
    try {
      await Preferences.set({
        key: this.storageAdminPlatformKey,
        value: platform + '',
      })
    } catch (err: any) {
      logIfDev(err)
    }
  }
  storeAuthentication = async (data: AuthenticationResponse) => {
    try {
      setAuthorization(data.accessToken)
      if (i18n.language !== data.user.lang) {
        changeLanguage(data.user.lang)
      } else {
        setLang(data.user.lang)
      }

      if (Constants.getIsLocal()) {
        await Preferences.set({
          key: this.storageAuthKey,
          value: JSON.stringify(data),
        })
      } else {
        // cross sub domain auth must use cookies
        Cookies.set(this.storageAuthKey, data.accessToken, {
          domain: Constants.cookiesDomain,
        })
      }
    } catch (err: any) {
      logIfDev(err)
    }
  }
  storeCountryParams = async (countryParams: CountryParams) => {
    try {
      await Preferences.set({
        key: this.storageCountryKey,
        value: JSON.stringify(countryParams),
      })
    } catch (err: any) {
      logIfDev(err)
    }
  }
  getCountryParams = async (user?: User): Promise<CountryParams | undefined> => {
    const isConnected = await NetworkUtils.isConnected()
    let countryParams: CountryParams | undefined

    if (isConnected) {
      const urlParams = new URLSearchParams(window.location.search)
      const countryQuery = urlParams.get('country') ?? undefined

      countryParams = await SessionsApi.getCurrentCountry(user, countryQuery)
    } else {
      try {
        const storedCountryParams = await Preferences.get({ key: this.storageCountryKey })
        countryParams = JSON.parse(storedCountryParams.value || '{}')
      } catch (err: any) {
        logIfDev(err)
      }
    }
    if (countryParams) {
      await this.storeCountryParams(countryParams)
      if (!Constants.specificCountry) {
        const getLocFilter = (state: any, route: string, isCatalog = true) => ({
          location: isCatalog
            ? {
                countryCode: countryParams?.countryCode,
                fullAddress: countryParams?.address,
              }
            : {
                location: {
                  countryCode: countryParams?.countryCode,
                  fullAddress: countryParams?.address,
                },
              },
          ...(state.filters[route] ?? {}),
        })
        this.store.update((state) => ({
          ...state,
          filters: {
            ...state.filters,
            ...(this.showPublicNeeds()
              ? {
                  '/public-catalogs/resources': getLocFilter(state, '/public-catalogs'),
                  '/public-materials/resources': getLocFilter(state, '/public-materials', false),
                  '/public-catalogs/needs': getLocFilter(state, '/public-catalogs'),
                  '/public-materials/needs': getLocFilter(state, '/public-materials', false),
                }
              : {
                  '/public-catalogs': getLocFilter(state, '/public-catalogs'),
                  '/public-materials': getLocFilter(state, '/public-materials', false),
                }),
          },
        }))
      }
    }

    return countryParams?.countryCode ? countryParams : undefined
  }

  getModeKey(key: string) {
    return this.store.getValue().modes[key] ?? undefined
  }

  setModeKey(key: string, modeKey: string) {
    this.store.update((state) => ({
      ...state,
      modes: {
        ...state.modes,
        [key]: modeKey,
      },
    }))
  }

  getFilter(key: string): Record<string, any> {
    return this.store.getValue().filters[key] ?? {}
  }
  setFilter(key: string, value: Record<string, any>) {
    this.store.update((state) => ({
      ...state,
      filters: {
        ...state.filters,
        [key]: value,
      },
    }))
  }

  async saveFilter(key: FilterableRoute) {
    const isConnected = await NetworkUtils.isConnected()
    const userId = sessionQuery.getUserId()
    if (isConnected && Constants.mode === Mode.admin && userId) {
      await SessionsApi.updateFilter(userId, key, this.store.getValue().filters[key])
    }
  }

  async init() {
    this.store.update(updateRequestStatus('init', 'pending'))

    try {
      let useImperials =
        (await Preferences.get({ key: this.storageUseImperialKey }))?.value === 'true'
      let adminPlatform = Number(
        (await Preferences.get({ key: this.storageAdminPlatformKey }))?.value ?? 1,
      )

      let user: User | undefined = undefined
      let accessToken: string | undefined = undefined
      if (Constants.getIsLocal()) {
        const auth = await Preferences.get({ key: this.storageAuthKey })
        ;({ user, accessToken } = JSON.parse(auth.value || '{}'))
      } else {
        // cross sub domain auth
        accessToken = Cookies.get(this.storageAuthKey)
      }

      if (accessToken) {
        setAuthorization(accessToken)
        const isConnected = await NetworkUtils.isConnected()
        if (isConnected) {
          try {
            user = await SessionsApi.getMe()
            await this.storeAuthentication({
              user,
              accessToken,
            })
          } catch (err: any) {
            accessToken = undefined
            logIfDev(err)
          }
        }
      }

      if (!user || !accessToken) {
        setAuthorization(undefined)
        const countryParams = await this.getCountryParams()
        this.store.update(
          (state) => ({
            ...state,
            useImperials,
            countryParams: countryParams ?? state.countryParams,
          }),
          updateRequestStatus('init', 'success'),
        )
        return
      }

      const countryParams = await this.getCountryParams(user)

      this.store.update(
        (state) => ({
          ...state,
          useImperials,
          countryParams: countryParams ?? state.countryParams,
          accessToken,
          user,
          adminPlatform: ((user as User).type === UserType.platformAdmin
            ? (user as User).platformOwned
            : !Number.isNaN(adminPlatform)
            ? adminPlatform
            : state.adminPlatform) as PlatformReference,
          filters:
            Constants.mode === Mode.admin ? { ...state.filters, ...user!.filters } : state.filters,
        }),
        updateRequestStatus('init', 'success'),
      )
    } catch (err: any) {
      this.store.update(updateRequestStatus('init', 'error', err))
      throw err
    }
  }

  logout = async () => {
    await Preferences.remove({ key: this.storageCountryKey })
    await Preferences.remove({ key: this.storageUseImperialKey })

    if (Constants.getIsLocal()) {
      await Preferences.remove({ key: this.storageAuthKey })
    } else {
      Cookies.remove(this.storageAuthKey, { domain: Constants.cookiesDomain })
    }

    setAuthorization(undefined)
    window.location.href = '/'
  }

  login = async (data: LoginInterface): Promise<AuthenticationResponse> => {
    await NetworkUtils.checkConnected()
    const authenticationResponse = await SessionsApi.login(data)

    if (
      authenticationResponse.user.type !== UserType.admin &&
      authenticationResponse.user.type !== UserType.platformAdmin &&
      Constants.mode === Mode.admin
    ) {
      throw new Error('UNAUTHORIZED')
    }

    const countryParams = await this.getCountryParams(authenticationResponse.user)

    this.store.update((state) => ({
      ...state,
      countryParams: countryParams ?? state.countryParams,
      ...authenticationResponse,
      adminPlatform:
        authenticationResponse.user.type === UserType.platformAdmin &&
        authenticationResponse.user.platformOwned
          ? authenticationResponse.user.platformOwned
          : state.adminPlatform,
      filters:
        Constants.mode === Mode.admin
          ? { ...state.filters, ...authenticationResponse.user.filters }
          : state.filters,
    }))
    await this.storeAuthentication(authenticationResponse)
    return authenticationResponse
  }

  updateLang = async (lang: LangEnum) => {
    changeLanguage(lang)
    const isConnected = await NetworkUtils.isConnected()
    if (isConnected && sessionQuery.getUserId()) {
      try {
        await this.updateMyAccount({ lang })
      } catch (err: any) {
        logIfDev(err)
      }
    }
  }

  updateMyAccount = async (data: Partial<ApiUser>): Promise<User> => {
    await NetworkUtils.checkConnected()
    const user = await SessionsApi.updateMe(sessionQuery.getUserId() as string, data)
    this.store.update((state) => ({
      ...state,
      user,
    }))
    return user
  }
  updateOrganization = (organization: Organization): void => {
    this.store.update((state) => ({
      ...state,
      user: {
        ...state.user!,
        organization,
      },
    }))
  }

  updateStats = async (incStats: UserStats) => {
    try {
      if (
        !Constants.getIsLocal() &&
        (Constants.mode === Mode.front || Constants.mode === Mode.storeFront)
      ) {
        this.store.update((state) => ({
          ...state,
          user: state.user
            ? {
                ...state.user,
                stats: (
                  [
                    'ordersW4Client',
                    'ordersW4Seller',
                    'allChatsW4Seller',
                    'allChatsW4Client',
                    'pendingRequests',
                  ] as (keyof UserStats)[]
                ).reduce((stats: UserStats, key: keyof UserStats) => {
                  stats[key] = (stats[key] ?? 0) + (incStats[key] ?? 0)
                  return stats
                }, state.user.stats ?? {}),
              }
            : state.user,
        }))
      }
    } catch (err) {
      logIfDev(err)
    }
  }

  signup = async (data: SignupInterface): Promise<void> => {
    await NetworkUtils.checkConnected()
    let kbis = !data.organization?._id
      ? await FilesApi.create(data.organization.kbis as File)
      : undefined
    let insurance =
      !data.organization?._id && data.organization.insurance
        ? await FilesApi.create(data.organization.insurance as File)
        : undefined
    await SessionsApi.signup({
      ...data,
      lang: i18n.language,
      organization: data.organization?._id ? data.organization._id : undefined,
      newOrganization: !data.organization?._id
        ? {
            ...data.organization,
            kbis: kbis?._id,
            insurance: insurance?._id,
          }
        : undefined,
    } as SignupInterfaceApi)
  }

  forgotPassword = async (email: string): Promise<void> => {
    await NetworkUtils.checkConnected()
    await SessionsApi.forgotPassword(
      email,
      Constants.mode === Mode.admin && !!sessionQuery.getUserId()
        ? this.getAdminPlatform()
        : undefined,
    )
  }

  deleteAccount = async (): Promise<void> => {
    await NetworkUtils.checkConnected()
    await SessionsApi.removeMe(sessionQuery.getUserId() as string)
  }

  contactUs = async (contactUsData: ContactUsData): Promise<void> => {
    await NetworkUtils.checkConnected()
    try {
      await SessionsApi.contactUs({
        ...contactUsData,
        translatedSubject: i18n.t(`sessions:subjects.${contactUsData.subject}`),
      })
    } catch (err: any) {
      err.error = 'CONTACT_US'
      throw err
    }
  }
}

export const sessionService = new SessionService()
